<template>
    <div class="modal fade" id="newBulletin" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <form method="POST" action="" @submit.prevent="addBulletin">
            <div class="modal-content">
                <div class="modal-header bg-light">
                    <h5 class="modal-title">New Bulletin</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div v-if="!saving" class="modal-body">
                    <div class="form-group row">
                        <label for="bulletin_text" class="col-form-label mx-2">Text:</label>
                        <textarea :class="['form-control', 'mx-2', errors.text ? 'is-invalid' : '']" id="bulletin_text" name="bulletin_text" v-model="newBulletin.text"></textarea>

                        <span v-if="errors.text" class="invalid-feedback mx-2">
                            <strong>{{ errors.text[0] }}</strong>
                        </span>
                    </div>
                    
                    <div class="form-group row">
                        <label for="dismissable" class="col-sm-4 col-form-label text-md-right">Dismissable</label>
                        <div class="col-md-6">
                            <div class="form-check">
                                <label>
                                    <input id="dismissable" type="checkbox" class="form-check-input" name="dismissable" v-model="newBulletin.dismissable">
                                </label>
                            </div>
                        </div>
                    </div>

                    
                    <div class="form-group row">
                        <label class="col-4 col-form-label text-md-right">Expiry Date</label>
                        <div class="col-md-6">
                            <input id="expiry_date" type="date" 
                                :class="['form-control', errors.expiry_time ? 'is-invalid' : '']" 
                                name="expiry_date" v-model="newBulletin.expiry_time" />
                        </div>
                        <div class="offset-sm-4 text-center"><small class="text-secondary">Leave blank to never expire</small></div>
                        
                        <span v-if="errors.expiry_time" class="invalid-feedback">
                            <strong>{{ errors.expiry_time[0] }}</strong>
                        </span>
                    </div>

                    <template v-if="pages.length > 1">
                        <div class="form-group row" v-for="page in pages" :key="page.id">
                            <label :for="'bulletinPage-' + page.id" class="col-sm-4 col-form-label text-md-right">{{page.name}}</label>

                            <div class="col-md-6">
                                <div class="form-check">
                                    <label>
                                        <input :id="'bulletinPage-' + page.id" type="checkbox" class="form-check-input" :value="page.id" v-model="newBulletin.page_ids">
                                    </label>
                                </div>
                            </div>
                        </div>
                    </template>

                </div>
                <div v-else class="modal-body">
                    Saving..
                </div>
                <div class="modal-footer bg-light">
                    <button type="button" class="btn btn-secondary" v-bind:class="{ disabled: saving }" @click="close()">Close</button>
                    <button type="submit" class="btn btn-primary" v-bind:class="{ disabled: saving }" @click="addBulletin()">Add Bulletin</button>
                </div>
            </div>
        </form>
    </div>
</div>
</template>

<script>
export default {
    name: "NewBulletinModal",

    props: {
        pages: {
            type: Array,
            required: true,
        },
        pageId: {
            type: Number,
            required: true,
        }
    },

    data() {
        return {
            newBulletin: {
                page_ids: [this.pageId]
            },
            saving: false,
            errors: [],
        }
    },

    methods: {
        addBulletin() {
            if (!this.saving) //debounce
            {
                var self = this;
                this.saving = true;
                axios.post('api/bulletins', this.newBulletin)
                .then(function (response) {
                    self.saving = false;
                    BulletinEventBus.$emit("reload");
                    self.close();
                })
                .catch(function (err) {
                    console.log(err); 
                    self.saving = false;
                    self.errors = err.response.data.errors;
                });
            }
        },

        close() {
            $('#newBulletin').modal('hide')
        }
    }
}
</script>